import labelIds from 'rde-view-common/locales/labelIds';
import MessageIds from 'rde-view-common/locales/MessageIds';

/**
 * APIエラー処理の定義ファイル
 * 引数が必要なメッセージはaxiosConfig.errorInfoに同様の形のオブジェクトとして渡す
 */
export default {
  '400_0100': {
    keepsSession: false,
    movesToErrorPage: true,
    messageId: MessageIds.MSG_COM_E_0010
  },
  '401_0101': {
    keepsSession: false,
    movesToErrorPage: true,
    messageId: MessageIds.MSG_COM_W_0410
  },
  '401_0102': {
    keepsSession: false,
    movesToErrorPage: true,
    messageId: MessageIds.MSG_COM_W_0410
  },
  '400_0200': {
    keepsSession: false,
    movesToErrorPage: true,
    messageId: MessageIds.MSG_COM_E_0010
  },
  '422_0201': {
    keepsSession: true,
    movesToErrorPage: false
  },
  '422_0202': {
    keepsSession: true,
    movesToErrorPage: false
  },
  '422_0203': {
    keepsSession: true,
    movesToErrorPage: false,
    messageId: MessageIds.MSG_COM_W_0200,
    messageParams: (e) => {
      const type = e.detail.match(/type=([^ ]*)/)[1];
      return [typeToLabelId[type]];
    }
  },
  '422_0204': {
    keepsSession: true,
    movesToErrorPage: false,
    messageId: MessageIds.MSG_COM_W_0220
  },
  '422_0205': {
    keepsSession: true,
    movesToErrorPage: false
  },
  '422_0206': {
    keepsSession: true,
    movesToErrorPage: false
  },
  '422_0207': {
    keepsSession: true,
    movesToErrorPage: false
  },
  '422_0208': {
    keepsSession: true,
    movesToErrorPage: false,
    messageId: MessageIds.MSG_COM_W_0240,
    messageParams: (e) => {
      let errParam = '';
      if (e?.source?.pointer?.includes('dataFiles')) {
        errParam = labelIds.SCR_DCV_4020__REGISTER_FILE;
      } else if (e?.source?.pointer?.includes('attachments')) {
        errParam = labelIds.COMMON_LABEL_ATTACHED_FILE;
      }
      return errParam;
    }
  },
  '403_0300': {
    keepsSession: true,
    movesToErrorPage: true,
    messageId: MessageIds.MSG_COM_W_0420
  },
  '404_0301': {
    keepsSession: false,
    movesToErrorPage: true,
    messageId: MessageIds.MSG_COM_E_0010
  },
  '404_0302': {
    keepsSession: true,
    movesToErrorPage: true,
    messageId: MessageIds.MSG_COM_W_0430
  },
  '409_0303': {
    keepsSession: true,
    movesToErrorPage: false
  },
  '409_0304': {
    keepsSession: true,
    movesToErrorPage: false
  },
  '409_0305': {
    keepsSession: false,
    movesToErrorPage: true,
    messageId: MessageIds.MSG_COM_E_0010
  },
  '405_0400': {
    keepsSession: false,
    movesToErrorPage: true,
    messageId: MessageIds.MSG_COM_E_0010
  },
  '500_0401': {
    keepsSession: false,
    movesToErrorPage: true,
    messageId: MessageIds.MSG_COM_E_0010
  },
  404: {
    keepsSession: false,
    movesToErrorPage: true,
    messageId: MessageIds.MSG_COM_E_0010
  },
  408: {
    keepsSession: true,
    movesToErrorPage: true,
    messageId: MessageIds.MSG_COM_W_0430
  },
  503: {
    keepsSession: false,
    movesToErrorPage: true,
    messageId: MessageIds.MSG_COM_E_0010
  },
  '409_1001': {
    keepsSession: true,
    movesToErrorPage: false,
    messageId: MessageIds.MSG_COM_W_0230,
    messageParams: [labelIds.COMMON_LABEL_GROUP, labelIds.COMMON_LABEL_DATASET_OR_SAMPLE]
  },
  '409_2001': {
    keepsSession: true,
    movesToErrorPage: false
  },
  '409_4001': {
    keepsSession: true,
    movesToErrorPage: false,
    messageId: MessageIds.MSG_COM_W_0230,
    messageParams: [labelIds.COMMON_LABEL_SAMPLE, labelIds.COMMON_LABEL_DATASET]
  },
  '409_4002': {
    keepsSession: true,
    movesToErrorPage: false,
    messageId: MessageIds.MSG_COM_W_0230,
    messageParams: [labelIds.COMMON_LABEL_SAMPLE, labelIds.SCR_SMP_1030_LABEL_OTHER_SAMPLE]
  },
  '409_4003': {
    keepsSession: true,
    movesToErrorPage: false,
    messageId: MessageIds.MSG_SMP_W_0010,
    messageParams: [labelIds.COMMON_LABEL_DATA, labelIds.COMMON_LABEL_GROUP]
  },
  '409_4004': {
    keepsSession: true,
    movesToErrorPage: false,
    messageId: MessageIds.MSG_SMP_W_0010,
    messageParams: [labelIds.COMMON_LABEL_RELATED_SAMPLE, labelIds.COMMON_LABEL_GROUP]
  },
  '422_4005': {
    keepsSession: true,
    movesToErrorPage: false,
    messageId: MessageIds.MSG_SMP_W_0020
  },
  '422_4006': {
    keepsSession: true,
    movesToErrorPage: false,
    messageId: MessageIds.MSG_SMP_W_0030
  },
  '409_4007': {
    keepsSession: true,
    movesToErrorPage: false,
    messageId: MessageIds.MSG_SMP_W_0040
  },
  '409_1002': {
    keepsSession: true,
    movesToErrorPage: false
  },
  '409_1003': {
    keepsSession: true,
    movesToErrorPage: false
  },
  '422_1004': {
    keepsSession: true,
    movesToErrorPage: false,
    messageId: MessageIds.MSG_DCV_W_0260
  },
  '422_1005': {
    keepsSession: true,
    movesToErrorPage: false,
    messageId: MessageIds.MSG_DCV_W_0270
  },
  '409_3001': {
    keepsSession: true,
    movesToErrorPage: false,
    messageId: MessageIds.MSG_COM_W_0230,
    messageParams: [labelIds.COMMON_LABEL_INSTRUMENTS, labelIds.COMMON_LABEL_DATASET]
  },
  '409_3002': {
    keepsSession: true,
    movesToErrorPage: false,
    messageId: MessageIds.MSG_INS_W_0020,
    messageParams: [labelIds.COMMON_LABEL_PROGRAM]
  },
  '409_1006': {
    keepsSession: true,
    movesToErrorPage: false,
    messageId: MessageIds.MSG_DCV_W_0280,
    messageParams: [labelIds.SCR_DCV_5040_DATASET_MANAGER]
  },
  '409_1007': {
    keepsSession: true,
    movesToErrorPage: false,
    messageId: MessageIds.MSG_DCV_W_0280,
    messageParams: [labelIds.SCR_DCV_5040_SAMPLE_ADMINISTRATOR]
  },
  '409_1008': {
    keepsSession: true,
    movesToErrorPage: false,
    messageId: MessageIds.MSG_DCV_W_0290,
    messageParams: [labelIds.SCR_DCV_5040_SAMPLE_ADMINISTRATOR]
  },
  '409_1009': {
    keepsSession: true,
    movesToErrorPage: false,
    messageId: MessageIds.MSG_DCV_W_0290,
    messageParams: [labelIds.SCR_DCV_5040_DATASET_MANAGER]
  },
  '409_1010': {
    keepsSession: true,
    movesToErrorPage: false,
    messageId: MessageIds.MSG_DCV_W_0290,
    messageParams: [labelIds.SCR_DCV_5040_DATA_OWNER]
  },
  '422_1011': {
    keepsSession: true,
    movesToErrorPage: false,
    messageId: MessageIds.MSG_COM_W_0240,
    messageParams: [labelIds.COMMON_LABEL_GROUP_NAME]
  },
  '409_1012': {
    keepsSession: true,
    movesToErrorPage: false,
    messageId: MessageIds.MSG_DCV_W_0300
  },
  '422_1013': {
    keepsSession: true,
    movesToErrorPage: false
  },
  '409_1014': {
    keepsSession: true,
    movesToErrorPage: false
  },
  '422_1015': {
    keepsSession: true,
    movesToErrorPage: false,
    messageId: MessageIds.MSG_DCV_W_0410
  },
  '409_1016': {
    keepsSession: true,
    movesToErrorPage: false,
    messageId: MessageIds.MSG_DCV_W_0430
  },
  '422_1018': {
    keepsSession: true,
    movesToErrorPage: false
  },
  '409_2002': {
    keepsSession: true,
    movesToErrorPage: false
  },
  '409_1018': {
    keepsSession: true,
    movesToErrorPage: false,
    messageId: MessageIds.MSG_DCV_W_0620
  },
  '409_1019': {
    keepsSession: true,
    movesToErrorPage: false,
    messageId: MessageIds.MSG_DCV_W_0610
  },
  '400_1022': {
    keepsSession: true,
    movesToErrorPage: false,
    messageId: MessageIds.MSG_DCV_W_0660
  },
  '422_1023': {
    keepsSession: true,
    movesToErrorPage: false,
    messageId: MessageIds.MSG_DCV_W_0650
  },
  '403_2003': {
    keepsSession: true,
    movesToErrorPage: false
  },
  '409_2004': {
    keepsSession: true,
    movesToErrorPage: false
  },
  '409_5001': {
    keepsSession: true,
    movesToErrorPage: false
  },
  '409_5002': {
    keepsSession: true,
    movesToErrorPage: false
  },
  default: {
    keepsSession: false,
    movesToErrorPage: true
  }
};

const typeToLabelId = {
  program: labelIds.COMMON_LABEL_PROGRAM,
  group: labelIds.COMMON_LABEL_GROUP,
  sample: labelIds.COMMON_LABEL_SAMPLE,
  dataset: labelIds.COMMON_LABEL_DATASET,
  instrument: labelIds.COMMON_LABEL_INSTRUMENTS,
  user: labelIds.COMMON_LABEL_USER,
  datasetTemplate: labelIds.COMMON_LABEL_DATASET_TEMPLATE,
  release: labelIds.COMMON_LABEL_RELEASE,
  file: labelIds.COMMON_LABEL_FILE,
  invoice: labelIds.COMMON_LABEL_INVOICE,
  license: labelIds.SCR_DCV_1020_LICENSE
};
